import React from 'react';
import { useSelector } from 'react-redux';

import {
  academyProjectModalStageSelector,
  ACADEMY_PROJECT_MODAL_STAGES,
} from 'features/classCreation';
import AcademyProjectModalCreateStage from '../AcademyProjectModalCreateStage';
import AcademyProjectModalDetailsStage from '../AcademyProjectModalDetailsStage';

export default function AcademyProjectModalStageRenderer() {
  const modalStage = useSelector(academyProjectModalStageSelector);

  switch (modalStage) {
    case ACADEMY_PROJECT_MODAL_STAGES.create:
      return <AcademyProjectModalCreateStage />;
    case ACADEMY_PROJECT_MODAL_STAGES.details:
      return <AcademyProjectModalDetailsStage />;
    default:
      return null;
  }
}
